// extracted by mini-css-extract-plugin
module.exports = {"welcome":"NFTDrop_welcome__F0aSI","storypara":"NFTDrop_storypara__oeP--"};